import Template from './Dashboard.njk';
import Marionette from "backbone.marionette";
import { DashboardHeaderView } from "../components/DashboardHeader";
import IncomingEventsView from "../incoming_events"
import { AvailableEvents } from "../../collections/AvailableEvents";
import { UpcomingEvents } from "../../collections/UpcomingEvents";
import { Config } from "../../application/Config";
import "./Dashboard.less";

/**
 * @param Seller model
 */
export const DashboardView = Marionette.View.extend({
  template: Template,
    className: "Dashboard",
    regions: {
        header: ".region-header",
        body: ".region-body"
    },

    initialize(options) {
        this.settings = options.settings;
    },

    onAttach() {
        this.showChildView('header', new DashboardHeaderView({
            model: this.model,
            settings: this.settings
        }));

        var eventCollection;
        switch (this.settings.events.capacity) {
            case "available":
                var options = {};
                if (this.settings.events.showGuides || this.settings.events.availability == "reserved") {
                    options.events = new UpcomingEvents()
                }
                eventCollection = new AvailableEvents(null, options);
                break;

            case "reserved":
                eventCollection = new UpcomingEvents();
                break;

            case "all":
                eventCollection = new AvailableEvents(null, {
                    events: new UpcomingEvents()
                });
                break;
        }

        this.showChildView('body', new IncomingEventsView({
            collection: eventCollection,
            filters: { seller: this.model },
            settings: this.settings
        }));
    },

    templateContext() {
        return {
            settings: this.settings,
            headerBackgroundUrl: Config.baseUrl.configuration ? Config.baseUrl.configuration + "/" + this.settings.header.backgroundImage : this.settings.header.backgroundImage
        }
    }
});


// WEBPACK FOOTER //
// ./src/js/view/pages/Dashboard.js